import { SCANNER_INTEGRATION_IDS } from "@/core/app/slices/integrations/scannerConstants"

import {
  clearScannerOAuthPopupMarker,
  hasRecentScannerOAuthPopupMarker,
  markScannerOAuthPopupOpened,
} from "./scannerOAuth"

/** API / Redux scanner key for EasyRx (headers use this value). */
export const EASYRX_SCANNER = SCANNER_INTEGRATION_IDS.EASYRX

/** Thin wrappers — OAuth protocol is generic; these pin the scanner to EasyRx. */
export function markEasyRxOAuthPopupOpened(): void {
  markScannerOAuthPopupOpened(EASYRX_SCANNER)
}

export function clearEasyRxOAuthPopupMarker(): void {
  clearScannerOAuthPopupMarker()
}

export function hasRecentEasyRxOAuthPopupMarker(): boolean {
  return hasRecentScannerOAuthPopupMarker(EASYRX_SCANNER)
}
